import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { getLogo, IResidentFile } from '@resident-nx/shared';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'rs-web-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, TranslateModule],
})
export class LogoComponent implements OnInit {
  public logo$: Observable<IResidentFile>;

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.logo$ = this.store.select(getLogo);
  }
}
